import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import "./AccountVerification.scss";
import {AXIOS} from "../../services/api";
import {Button} from "../../components/button/Button";

const AccountVerification = () => {
	const {id, hash} = useParams();
	const navigate = useNavigate();
	const [status, setStatus] = useState('loading');

	useEffect(() => {
		const verifyEmail = async () => {
			try {
				const response = await AXIOS.post(`/account/verify/${id}/${hash}`);
				console.log(response);
				if (response.status === 200) {
					setStatus('success');
				}
			} catch (error) {
				console.log(error);
				setStatus('error');
			}
		};

		verifyEmail().then();
	}, [id, hash]);

	return (
		<div className="email-verification">
			{status === 'loading' && <p>Verifying your email...</p>}
			{status === 'success' && (
				<>
					<p>Email verified successfully!</p>
					<Button
						label="Continue"
						variant={"primary"}
						onClick={() => navigate('/')}
					/>
				</>
			)}
			{status === 'error' && (
				<>
					<p>Verification failed. The link may be expired or invalid.</p>
					<Button
						label="Continue"
						variant={"primary"}
						onClick={() => navigate('/')}
					/>
				</>
			)}
		</div>
	);
};

export default AccountVerification;
